import {
  formatAnalyticsCurrency,
  type CurrencyFormatOptions,
} from "../shared/analyticsFormatting";
import type { ServiceAvailabilityDay } from "./mockData";

export type TopServicesAvailabilityDay = "all" | ServiceAvailabilityDay;

export type TopServicesFiltersState = {
  panelSearch: string;
  serviceActivity: {
    activities: boolean;
    services: boolean;
  };
  priceRange: [number, number];
  /** Empty array means all hotel categories are included. */
  categoryIds: string[];
  availability: TopServicesAvailabilityDay[];
};

export const TOP_SERVICES_PRICE_MIN = 0;
export const TOP_SERVICES_PRICE_MAX = 10000;

export const TOP_SERVICES_AVAILABILITY_OPTIONS: {
  key: TopServicesAvailabilityDay;
  label: string;
}[] = [
  { key: "all", label: "All" },
  { key: "monday", label: "Monday" },
  { key: "tuesday", label: "Tuesday" },
  { key: "wednesday", label: "Wednesday" },
  { key: "thursday", label: "Thursday" },
  { key: "friday", label: "Friday" },
  { key: "saturday", label: "Saturday" },
  { key: "sunday", label: "Sunday" },
];

export const DEFAULT_TOP_SERVICES_FILTERS: TopServicesFiltersState = {
  panelSearch: "",
  serviceActivity: {
    activities: true,
    services: true,
  },
  priceRange: [TOP_SERVICES_PRICE_MIN, TOP_SERVICES_PRICE_MAX],
  categoryIds: [],
  availability: ["all"],
};

export function countActiveTopServicesFilters(
  filters: TopServicesFiltersState,
  totalCategoryCount = 0,
): number {
  let count = 0;

  if (filters.panelSearch.trim()) {
    count += 1;
  }

  if (
    !filters.serviceActivity.activities ||
    !filters.serviceActivity.services
  ) {
    count += 1;
  }

  if (
    filters.priceRange[0] !== TOP_SERVICES_PRICE_MIN ||
    filters.priceRange[1] !== TOP_SERVICES_PRICE_MAX
  ) {
    count += 1;
  }

  if (
    totalCategoryCount > 0 &&
    filters.categoryIds.length > 0 &&
    filters.categoryIds.length < totalCategoryCount
  ) {
    count += 1;
  }

  if (filters.availability.length !== 1 || filters.availability[0] !== "all") {
    count += 1;
  }

  return count;
}

export function formatTopServicesPriceRange([min, max]: [
  number,
  number,
]): string {
  const priceFormat: CurrencyFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    symbol: "€",
    symbolPosition: "suffix",
  };
  return `${formatAnalyticsCurrency(min, priceFormat)}-${formatAnalyticsCurrency(max, priceFormat)}`;
}
